import Vue from 'vue'
import { normalize, schema } from 'normalizr'
import { checkStatus, getHeaders, parseJSON, buildUrlWithQuery } from '@/utils/api'
import {
  receiveData,
  receiveMetadata,
  resetMetadata
} from '@/store/modules/helpers/mutationHelpers'

const srs = new schema.Entity('srs')
const searchresultsListSchema = new schema.Array(srs)

const state = {
  searchKey: '',
  data: {},
  cache: {},
  count: null,
  shown: null,
  next: null,
  previous: null,
  isReceivingData: false,
  currentPage: 1
}

const actions = {
  async updateSearchkey ({commit, dispatch}, payload) {
    await commit('setSearchKey', payload)
    await dispatch('fetchSearchData', {search: payload})
  },
  fetchSearchData ({commit}, query) {
    const instanceUrl = this.getters.getActiveInstance.url
    const headers = getHeaders(this.getters.getToken)
    commit('RECEIVING_RESULTS', true)

    return Vue.http.get(buildUrlWithQuery(`pa_search/`, query, instanceUrl), { headers })
    .then(checkStatus)
    .then(parseJSON)
    .then(r => {
      if (r.hasOwnProperty('results')) {
        commit('RECEIVING_RESULTS', false)
        const { results, next, previous, count } = r
        const { entities, result } = normalize(
          results.map((item, index) => ({ ...item, id: Number(item.transaction_id + '' + index) })),
          searchresultsListSchema
        )

        let mutationPayload = { data: entities.srs }
        if (query && query.page && typeof query.page === 'number') {  // If query contains a page number
          mutationPayload.page = query.page                           // pass the page number to the mutation handler
        }

        commit('RECEIVE_SEARCHRESULTS', mutationPayload)
        commit('RECEIVE_SEARCHRESULTS_METADATA', { next, previous, count, result: result.length })
        commit('UPDATE_CURRENT_SEARCHRESULTS_PAGE', query.page || 1)
        return { query, count, entities }
      }
    })
    .catch(e => {
      commit('RECEIVING_RESULTS', false)
      console.log(e)
      return e
    })
  },
  clearSearchResultsState ({commit}, payload = null) {
    return commit('CLEAR_SEARCHRESULTS_STATE', payload)
  },
  resetSearchResultsMeta ({commit}) {
    return commit('RESET_SEARCHRESULTS_META')
  }
}

const getters = {
  getSearchResults: (state) => state.data,
  getSearchKey: (state) => state.searchKey,
  getSearchResultsMetadata: (state) => {
    const { shown, count, next, previous } = state
    if (!shown) return { count: 0, shown: 0 }
    return { count, shown, next, previous }
  },
  getReceivingDataStatus: (state) => state.isReceivingData,
  getCurrentSearchResultsPage: (state) => state.currentPage
}

const mutations = {
  RECEIVING_RESULTS (state, payload) {
    state.isReceivingData = payload
  },
  UPDATE_CURRENT_SEARCHRESULTS_PAGE (state, page) {
    state.currentPage = page
  },
  RECEIVE_SEARCHRESULTS_METADATA (state, payload) {
    receiveMetadata(state, payload)
  },
  RECEIVE_SEARCHRESULTS (state, results) {
    receiveData(state, results)
  },
  setSearchKey (state, payload) {
    state.searchKey = payload
  },
  CLEAR_SEARCHRESULTS_STATE (state, payload) {
    let newState = {
      data: Object.assign({}),
      lines: Object.assign({}),
      saving: { status: false, err: null },
      receiveDataFailure: false,
      deleting: false
    }
    if (payload) {
      if (Array.isArray(payload) && payload.length) {
        payload.forEach(v => {
          if (newState.hasOwnProperty(v)) delete newState[v]
        })
      } else {
        newState['cache'] = Object.assign({})
      }
    }
    for (let key in newState) {
      state[key] = newState[key]
    }
  },
  RESET_SEARCHRESULTS_META (state) {
    resetMetadata(state)
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/searchResults.js